<sbnb-logo routerLink="/user/hello"></sbnb-logo>
<router-outlet></router-outlet>
